/**
 * Copyright 2023 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
export const replaceSEOMetadataPlaceholder = (
  inputString: string,
  skuName: string | undefined
): string => {
  return inputString.replace(/{sku_name}/g, skuName ?? '');
};
